import { render, staticRenderFns } from "./TextBubble.vue?vue&type=template&id=57774530&scoped=true&lang=pug&"
import script from "./TextBubble.vue?vue&type=script&lang=ts&"
export * from "./TextBubble.vue?vue&type=script&lang=ts&"
import style0 from "./TextBubble.vue?vue&type=style&index=0&id=57774530&lang=scss&scoped=true&"
import style1 from "./TextBubble.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57774530",
  null
  
)

export default component.exports